import { render, staticRenderFns } from "./hyrox-zone-preview.component.vue?vue&type=template&id=21b58ff0&scoped=true"
import script from "./hyrox-zone-preview.component.ts?vue&type=script&lang=ts&external"
export * from "./hyrox-zone-preview.component.ts?vue&type=script&lang=ts&external"
import style0 from "./hyrox-zone-preview.component.scss?vue&type=style&index=0&id=21b58ff0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b58ff0",
  null
  
)

export default component.exports